import React from 'react';

import { ChildrenProps } from '../../../utils';
import { BannerType } from '../Banner/Banner';
import { Banner } from '../index';

type Props = ChildrenProps;

const BannerWarning = ({ children }: Props) => {
  return (
    <>
      <Banner type={BannerType.WARNING}>{children}</Banner>
    </>
  );
};

export default BannerWarning;
